<template>
  <div
    class="evaluation-viewer-section"
    :class="section.$group">
    <h1><span class="index">{{ index.join('.') }}</span> {{ section.name }}</h1>
    <main
      v-for="(children, $index) of section.$children"
      :key="children.$id"
    >
      <evaluation-viewer-question
        v-if="children.$group === 'question'"
        :index="[...index, $index + 1]"
        :question="children"
      />
      <evaluation-viewer-section
        v-else
        :index="[...index, $index + 1]"
        :section="children"
      />
    </main>
  </div>
</template>

<script>
import EvaluationViewerQuestion from '@/modules/evaluation-viewer/components/evaluation-viewer-question'
/**
   * 'EvaluationViewerSection' Component
   * @version 1.0.0
   * @author Fernando Torres
   * @copyright Marciano Studio S.C., 2018
   */
export default {
  name: 'EvaluationViewerSection',
  components: {EvaluationViewerQuestion},
  props: {
    index: {
      type: Array,
      required: true
    },
    section: {
      type: Object,
      required: true
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
    .evaluation-viewer-section {
      h1{
        @include font-primary(18px, regular);
        display: block;
        background-color: #f0f0f0;
        padding: 20px;
        margin: 0;
        span.index{
          display: inline-block;
          background-color: $color-ui-primary;
          color: #fff;
          padding: 3px;
          min-width: 18px;
          text-align: center;
          border-radius: 2px;
          margin-right: 10px;
        }
      }
      &.subsection{
        h1{
          background-color: #f4f4f4;
          padding-left:40px;
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/modules/evaluation-viewer/components/evaluation-viewer-section.vue